import getApi from '../../api'

export const deleteMedicalEvent = (id: number) => getApi().delete<void>(`/medical_events/${id}`)
